import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import { engineListener } from '../app-interfaces/actions/engineListener';
import appReducer from '../slices/appSlice';
import cardsReducer from '../slices/cardsSlice';
import counterReducer from '../features/counter/counterSlice';
import outputReducer from '../slices/outputSlice';
import tableReducer from '../slices/tableSlice';
import warReducer from '../slices/warSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        cards: cardsReducer,
        table: tableReducer,
        output: outputReducer,
        war: warReducer,
        // example
        counter: counterReducer,
    },
    devTools: process.env.NODE_ENV === 'development', // ✅ Add this line
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).prepend(
            engineListener.middleware, // 👈 engine “listeners” go here
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
